import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { EVENT_QUERIES } from "~/shared/api/events/events.queries";
import { notFound } from "~/shared/util/notFound";

export async function eventEditViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { eventId } = params;

  if (!eventId) {
    return notFound();
  }

  queryClient.prefetchQuery(EVENT_QUERIES.detail(parseInt(eventId)));

  return null;
}
